import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";

export default function WellnessPatientIntro({getWellnessError, wellnessFormData,setWellnessFormData}) {
    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/patient_1.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Section Title'}
            value={wellnessFormData?.registerTitle}
            setValue={(value) => setWellnessFormData({registerTitle:value})}
            errorMessage={getWellnessError('surveySettings','registerTitle')}
        />
    </div>
}
